<div class="offer-bottom-popup">
  <ion-icon name="close-outline" (click)="close()" *ngIf="freeTrialStartedAt"
    style="font-size: 2rem; position: fixed; color: #01A3A4; z-index: 1;right: 30px;">
  </ion-icon>

  <ion-card *ngIf="!freeTrialStartedAt">
    <!-- <ion-card-header class="ion-text-center" style="padding-bottom: 0;">
      <img src="assets/img/celebrate.svg">
    </ion-card-header> -->
    <ion-card-header class="ion-text-center" style="padding-bottom: 0;">
      <div class="ion-text-center title">Free  <span>Trial</span></div>
    </ion-card-header>
    <ion-card-content class="ion-margin-horizontal ion-text-center">
      <ion-row>
        <ion-col style="margin-top: 1rem;">
          <ion-slides [options]="slideOptsActivity" pager="true">
            <ion-slide #activitySlide *ngFor="let activity of activitySlider; let i = index">
              <!-- <ion-card [ngStyle]="{'border-color':activity.bgcolor}" -->
              <ion-card style="border-radius: 30px;padding: 5px 10px 10px;width: 100%;box-shadow: none;">
                <!-- <div style=" background: #fff; height: 130px; margin: auto; border-radius: 100%; width: 130px; display: flex;"> -->
                <div style=" background: #fff; height: 150px; margin: 0 auto 0; border-radius: 100%;box-shadow: rgb(0 0 0 / 0%) 0px 4px 16px;">
                  <img [src]="activity.image" style="height:100vh; position: relative; top: 20px;" />
                </div>
                <!-- </div> -->
                <div style="color:#434343; font-weight: bold; font-size: 1.2rem; margin-top: 30px; padding-bottom: 5px;">
                  <img src="assets/img/premium-crown.png" style="padding-right: 5px;height: 20px;"  /> {{activity.title}}</div>
                <div style="color:#363939; font-size: 0.9rem; padding-bottom: 5px;">
                  {{activity.subtitle}}
                </div>
              </ion-card>
            </ion-slide>
          </ion-slides>
        </ion-col>
      </ion-row>
      <div style="font-size: 1rem; font-weight: bold;padding-top: 0;padding-bottom: 0;margin-top: -10px;" class="ion-padding">You can try premium experience for {{freeTrialDays}} days</div>

      <!-- <ion-item class="line-height-2">
        <ion-label position="fixed" class="width50">From</ion-label>
        <ion-datetime style="padding-right: 0;" slot="end" displayFormat="HH:mm" mode="ios" [(ngModel)]="fromTimeFasting"
          [value]="fromTimeFasting" (ionChange)="changeTime($event, false)" [max]='maxTime' [min]='minTime'>
        </ion-datetime>
      </ion-item> -->
      <ion-row class="ion-padding-vertical">
        <ion-col class="ion-text-center">
          <ion-button class="start-fasting" (click)="startFreeTrial()">Start your free trial</ion-button>
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="freeTrialStartedAt">
    <ion-card-header class="ion-text-center" style="padding-bottom: 0;">
      <div class="ion-text-center title">Special Offer <span>Expiring</span></div>
    </ion-card-header>
    <ion-card-content class="ion-margin-horizontal ion-text-center">

      <ion-row class="free-plan-container">
        <ion-col style="margin-top: 1rem;">
          <ion-slides [options]="slideOptsActivity" pager="true">
            <ion-slide #activitySlide *ngFor="let activity of activitySlider; let i = index">
              <!-- <ion-card [ngStyle]="{'border-color':activity.bgcolor}" -->
              <ion-card style="border-radius: 30px;padding: 5px 10px 10px;width: 100%;box-shadow: none;">
                <!-- <div style=" background: #fff; height: 130px; margin: auto; border-radius: 100%; width: 130px; display: flex;"> -->
                <div style=" background: #fff; height: 150px; margin: 0 auto 0; border-radius: 100%;box-shadow: rgb(0 0 0 / 0%) 0px 4px 16px;">
                  <img [src]="activity.image" style="height:100vh;position: relative; top: 20px;" />
                </div>
                <!-- </div> -->
                <div style="color:#434343; font-weight: bold; font-size: 1.2rem; margin-top: 30px;">
                  <img src="assets/img/premium-crown.png" style="padding-right: 5px;height: 20px;" />{{activity.title}}</div>
                <div style="color:#363939; font-size: 0.9rem;">
                  {{activity.subtitle}}
                </div>
              </ion-card>
            </ion-slide>
          </ion-slides>
        </ion-col>
      </ion-row>

      <!-- <ion-row>
        <ion-col>
          <span style="font-size: 1rem; font-weight: bold;" >{{freeTrialDays}} days Left</span>
        </ion-col>
      </ion-row> -->

      <ion-row class="ion-text-center"> 
        <!-- <ion-col size="2" class="ion-text-center logo">
          <div>
            <img src="./assets/img/gift.gif">
          </div>
        </ion-col> -->
        <ion-col class="content-header" *ngIf="country == 'IND'">
          <!-- <ion-row class="content-header"> -->
            <!-- <ion-col class="ion-text-left"> -->
              {{data.perid}} Months Plan <span class="color-gold">₹</span><span class="strike">{{data.amount}}</span><span class="color-gold"> {{data.discountedAmount}}</span>
            <!-- </ion-col> -->
          <!-- </ion-row> -->
        </ion-col>
        <ion-col class="content-header" *ngIf="country != 'IND'">
          <!-- <ion-row class="content-header"> -->
            <!-- <ion-col class="ion-text-left"> -->
              {{data.perid}} Months Plan <span class="color-gold">$</span> <span class="strike">{{data.message4}}</span><span class="color-gold"> {{data.dollarPrice}}</span>
            <!-- </ion-col> -->
          <!-- </ion-row> -->
        </ion-col>
      </ion-row>

      <!-- <ion-row>
        <ion-col>
          <span style="font-size: 1.2rem;" >Use Coupon Code: {{couponCode}}</span>
        </ion-col>
      </ion-row> -->

      <ion-row *ngIf="freeTrialEndDateDiff > 0">
        <ion-col>
          <span style="font-size: 0.8rem;" >Special offer expires in {{freeTrialEndDateDiff}} days</span>
        </ion-col>
      </ion-row>

      <ion-row class="ion-text-center" style="font-size: 1.5rem;" *ngIf="freeTrialEndDateDiff == 0">
        <ion-col class="ion-text-right">
          <b style="color: #01A3A4;">{{countdownHours}}</b>
        </ion-col>
        <ion-col size="1.5">
          <b style="color: #01A3A4;">:</b>
        </ion-col>
        <ion-col class="ion-text-left">
          <b style="color: #01A3A4;">{{countdownMins}}</b>
        </ion-col>
      </ion-row>

      <ion-row class="ion-text-center" *ngIf="freeTrialEndDateDiff == 0">
        <ion-col class="ion-text-right">
          <span>HRS</span>
        </ion-col>
        <ion-col size="1.5">
         
        </ion-col>
        <ion-col class="ion-text-left">
          <span>MIN</span>
        </ion-col>
      </ion-row>

      <!-- <ion-item class="line-height-2">
        <ion-label position="fixed" class="width50">From</ion-label>
        <ion-datetime style="padding-right: 0;" slot="end" displayFormat="HH:mm" mode="ios" [(ngModel)]="fromTimeFasting"
          [value]="fromTimeFasting" (ionChange)="changeTime($event, false)" [max]='maxTime' [min]='minTime'>
        </ion-datetime>
      </ion-item> -->

      <!-- <ion-row class="ion-padding-top">
        <ion-col class="ion-text-center">
          <ion-button fill="outline" class="cancel-fasting" (click)="close()">Cancel</ion-button>
        </ion-col>
      </ion-row> -->

      <ion-row class="ion-padding-vertical">
        <ion-col class="ion-text-center">
          <ion-button class="start-fasting-subscribe" (click)="startSpecialTrial()">Subscribe with offer</ion-button>
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>
</div>